'use client'

import defaultLocale from '@/stores/defaultLocale'
import getLocale from '@/stores/locales'
import { UseClientModelContext } from '@mercadoni/sinister/dist/cjs/client'
import { Footer } from '@mercadoni/sinister/dist/cjs/footer'
import { useGroupedPages } from '@mercadoni/sinister/dist/cjs/header'
import { useIsMobile } from '@mercadoni/sinister/dist/cjs/shared/hooks'
import { useEffect, useState } from 'react'
import VisibleElement from '../VisibleElement'
import styles from './Footer.module.scss'

const FooterComponent = ({ userAgent }: { userAgent?: string }) => {
  const copies = getLocale() || defaultLocale
  const { groupedPages } = useGroupedPages({ position: 'footer' })
  const { help, helpV3, buildVersion, footer } = UseClientModelContext()
  const [isMobile] = useIsMobile(userAgent)
  const [showFooter, setShowFooter] = useState(false)

  const { showExpandedGroupedPages = false } = footer || {}

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFooter(true)
    }, 3000)

    return () => clearTimeout(timer)
  }, [])

  if (!showFooter) return null

  return (
    <VisibleElement
      offset="100px"
      height={100}
      timer={3000}
      dataName="footer"
      defaultDisplay={false}
    >
      <>
        <Footer
          copies={copies}
          groupedPages={groupedPages}
          help={help}
          helpV3={helpV3}
          isMobile={isMobile}
          showExpandedGroupedPages={showExpandedGroupedPages}
        />
        <div className={styles['footer__build-version']}>
          {buildVersion}.{process.env.GIT_COMMIT_HASH}
        </div>
      </>
    </VisibleElement>
  )
}

export default FooterComponent
